module.exports = __webpack_public_path__ + "static/media/noZipper.0f9dabf7.svg";